import store_consultation from "@/store/mods/clinique/consultations"
import store_analyse from "@/store/mods/clinique/analyses"
import store_examen from "@/store/mods/clinique/examens"
import store_stock from "@/store/mods/stock/produits"

import $ from 'jquery';
export default {
    name: "all-consultations-list",
    components: {},
    props: [],
    data() {
        return {
            filter: "",
            perPage: 15,
            currentPage: 1,

            fields: ["No", "Patient", "type_consultation", "Date", "Actions"],
            fields2: ["No", "Patient", "Date"],
            analyses_examens_fields: ["No", "Patient", "Date"],
            bon_field: ["ref", "patient", "date"],
            
            pharmacies_fields: ["No", "client", "Date"],
            examens_datas: [],
            pharmacies_datas: [],
            pharmacies_rows: 0,
            soins_datas: [],

            facture_loading: true,
            facture_empty: false,

            exam_facture_is_empty: false,
            exam_facture_loading: true,
            config_to_show: 1,

            bon_analyse_is_empty: false,
            bon_analyse_is_loading: true,

            factures: [],
            facture_length: 0,

            analyses_rows: 0,
            liste_analyse_externe: [],
            examens_rows: 0,
            facture_examens: [],

            soins_empty: false,
            soins_loading: true,

            anl_loading: true,
            anl_empty: false,

            pharma_loading: true,
            pharma_empty: false

        };
    },
    computed: {
        consultations() {
            return this.$store.getters["allConsultations"];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        bon_analyse_sans_consultation() {
            return this.$store.getters['bon_analyse_sans_consultation'];
        },
    },
    mounted() {
        setTimeout(() => {
            $(".shw").fadeIn();
        }, 500);


        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1 //  Caisse principale
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4 //  Caisse 1 (Infirmier)
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3 //  Comptabilité
            }
        }

        // >>>> Etat d'ouverture d'une caisse
        this.$store.dispatch('getStatutOuvertureCaisse', this.compte_id).then((response) => {
            if (response == 1) {
                this.$router.push({ path: '/clinicaa/comptabilite/caisse' })
            }
        });

        // Liste facture avec consultations 
        store_consultation.getAllFactures().then((factures) => {
            this.factures = factures
            this.facture_loading = false

            this.facture_length = this.factures.length
            if (this.factures.length == 0) {
                this.facture_empty = true
            }
        })
        

        //RETRIEVE THE ANALYSE DATAS
        store_analyse.getAllAnalysesForExterne().then((analyses) => {
            this.liste_analyse_externe = analyses
            this.analyses_rows = this.liste_analyse_externe.length

            if (this.liste_analyse_externe.length == 0) {
                this.anl_empty = true 
            } else {
                this.anl_empty = false
            }

            this.anl_loading = false
        })

        //RETRIEVE THE EXAMENS DATAS
        store_examen.getAllExamensForExterne().then((examens) => {
            this.facture_examens = examens
            this.examens_rows = this.facture_examens.length
            if (this.facture_examens.length > 0) {
                this.exam_facture_is_empty = false 
            } else {
                this.exam_facture_is_empty = true
            }
            this.exam_facture_loading = false
        });

        //RETRIEVE THE PHARMACIES DATAS
        store_stock.getVentesExterne().then((produits) => {
            this.pharmacies_datas = produits;
            this.pharmacies_rows = this.pharmacies_datas.length
            if (this.pharmacies_datas.length == 0) {
                this.pharma_empty = true 
            } else {
                this.pharma_empty = false
            }

            this.pharma_loading = false
        });

        //RETRIEVE SOINS SANS CONSULTATIONS DATAS
        store_consultation.getSoinsSansConsultation().then((soins) => {
            this.soins_datas = soins
            if (soins.length == 0) {
                this.soins_empty = true
            } else {
                this.soins_empty = false
            }

            this.soins_loading = false
        })
    },
    methods: {
        changeTab(tabindex) {
            this.config_to_show = tabindex
        },

        customDateFormat(given_date) {
            let only_date = "",
                only_hour = "";
            let date = new Date(given_date);
            let month = date.getMonth() + 1;
            only_date = date.getDate() + "/" + month + "/" + date.getFullYear();
            let c_hour = date.getHours();
            let c_minute = date.getMinutes();
            if (c_hour < 10) c_hour = "0" + c_hour;
            if (c_minute < 10) c_minute = "0" + c_minute;
            only_hour = c_hour + ":" + c_minute;

            return only_date + " " + only_hour;
        },

        /** */
        fetchBonanalyseSansConsultation() {
            this.bon_analyse_is_loading = true

            this.$store.dispatch("getBulletinAnalyseSanConsultation").then(() => {
                if (this.bon_analyse_sans_consultation.length > 0) {
                    this.bon_analyse_is_empty = false
                } else {
                    this.bon_analyse_is_empty = true
                }
                this.bon_analyse_is_loading = false
            });
        },

        viewAnalyse(url) {
            this.$router.push({"path": url})
        },

        // apres sélection d'un patient ayant effectué une analyse
        choosePatient: function(demandes, patient, exam) {
            if (exam == 'examen') { // c'est un choix d'examen
                let exams_to_set = [];
                demandes.forEach((element) => {
                    exams_to_set.push({
                        id: element.type_examen.id,
                        nom: element.type_examen.nom,
                        prix: element.type_examen.prix,
                    });
                });
                this.$store.commit("SET_EXAMENS_SELECTED", exams_to_set);
                this.$store.commit("SET_ANALYSES_SELECTED", []);

            } else { // c'est un choix d'analyse
                let anal_to_set = [];
                demandes.forEach(
                    (element) => {
                        anal_to_set.push({
                            id: element.analyse.id,
                            nom: element.analyse.nom,
                            prix: element.analyse.prix,
                        });
                    }
                );
                this.$store.commit("SET_ANALYSES_SELECTED", anal_to_set);
                this.$store.commit("SET_EXAMENS_SELECTED", []);
            }

            this.$store.commit(
                "SET_PATIENT", {
                    id: patient.id,
                    nom: patient.nom,
                    prenoms: patient.prenoms,
                }
            );
        },
    },
};